var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 16,
    viewBox: "0 0 13.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check",
    d: "M13.054,1.427,8.877.034a.667.667,0,0,0-.421,0L4.279,1.427A3.329,3.329,0,0,0,2,4.589V8c0,5.042,6.133,7.827,6.4,7.943a.667.667,0,0,0,.541,0c.263-.116,6.4-2.9,6.4-7.943V4.589a3.329,3.329,0,0,0-2.279-3.162ZM11.812,6.478,8.964,9.326a1.249,1.249,0,0,1-.89.369H8.052a1.248,1.248,0,0,1-.9-.4l-1.537-1.6a.667.667,0,1,1,.961-.921l1.5,1.56,2.792-2.8a.667.667,0,1,1,.943.943Z",
    transform: "translate(-2 0)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.78026fe34aff11506ff20b2cd1211026.svg";
export { ForwardRef as ReactComponent };